module.exports = __webpack_public_path__ + "img/icon.bba2962f.png";